var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-container"},[_c('div',{staticClass:"welcome-sprite"},[_c('div',{class:("w" + (_vm.frame.toFixed(0)))})])])}
var staticRenderFns = []

export { render, staticRenderFns }